import L from 'leaflet';
import { wmsLayers } from './wmsLayers';

const osmBaseLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { zIndex: 100 });
const whiteTileLayer = L.gridLayer({
  attribution: 'Nenhuma camada base',
  pane: 'tilePane'
});
const statusPadrao = [
  { name: "À executar" },
  { name: "Executado" },
  { name: "Entregue" },
  { name: "Aprovado" },
  { name: "Aprovado com Pendência" },
  { name: "Filtrar por BE", type: "be-filter" }
];

const lotesProjeto = [
  { name: "Lote 1" }, { name: "Lote 2" }, { name: "Lote 3" }, { name: "Lote 4" },
  { name: "Lote 5" }, { name: "Lote 6" }, { name: "Lote 7" }, { name: "Lote 8" },
  { name: "Lote 9" }, { name: "Lote 10" }, { name: "Lote 11" }, { name: "Lote 12" }
];

whiteTileLayer.createTile = function (coords) {
  const tile = document.createElement('div');
  tile.style.background = 'white';
  return tile;
};

export const baseLayers = [
  {
    name: 'Vazio',
    layer: whiteTileLayer,
    icon: '<i class="icon icon-map"></i>',
  },
  {
    name: 'OpenStreetMap',
    layer: osmBaseLayer,
    icon: '<i class="icon icon-map"></i>',
  },
];

export const overLayers = [
  {
    group: "Informações Gerais",
    layers: [
      { name: "Lotes do Projeto", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>', children: lotesProjeto },
      { name: "Blocos de Entrega", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>', children: lotesProjeto },  
      { name: "Articulação Sistemática 1:5.000", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>' },
      { name: "Articulação Sistemática 1:10.000", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>' },
      { name: "Articulação Sistemática 1:25.000", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>' },
      { name: "Articulação Auxiliar 1:5.000", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>' },
      { name: "Articulação Auxiliar 1:10.000", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>' },
      { name: "Área de Abrangência do Projeto", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>' },
      { name: "Limite Municipais", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>' },
      { name: "Limite Estadual - PR", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>' },
      { name: "Caminho do Peabiru", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>' },
    ]
  },
  {
    group: "Andamento dos Produtos",
    layers: [
      { name: "Recobrimento Aerofotogramétrico", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>', children: statusPadrao },
      { name: "Apoio de Campo - Classe II - PCL", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>', children: statusPadrao },
      { name: "Apoio de Campo - Classe II - HV e PCA", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>', children: statusPadrao },
      { name: "Fotoíndice", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>', children: statusPadrao },
      { name: "Perfilamento a LASER Aerotransportado", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>', children: statusPadrao },
      { name: "Classificação da Nuvem De Pontos", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>', children: statusPadrao },
      { name: "Modelo Digital de Superficie - MDS", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>', children: statusPadrao },
      { name: "Modelo Digital de Terreno - MDT", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>', children: statusPadrao },
      { name: "Imagem Hipsométrica Composta", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>', children: statusPadrao },
      { name: "Imagem de Intensidade", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>', children: statusPadrao },
      { name: "Aerotriangulação", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>', children: statusPadrao },
      { name: "Ortofotomosaico RGB/NIR", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>', children: statusPadrao },
      { name: "Curvas de Nível", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>', children: statusPadrao },
      { name: "Base Hidrográfica", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>', children: statusPadrao },
      { name: "Base Hidrográfica Ottocodificada", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>', children: statusPadrao },
      { name: "Restituição Planimétrica", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>', children: statusPadrao },
      { name: "Reambulação", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>', children: statusPadrao },
      { name: "Edição Gráfica", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>', children: statusPadrao }
    ]
  },
  {
    group: "Informações de Voo",
    layers: [
      { name: "Aeroporto", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>' },
      { name: "Bases de Voo", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>' },
      { name: "RBMC", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>' },
      { name: "GPS", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>' },
      { name: "RN", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>' }
    ]
  },
  {
    group: "Base de Dados",
    layers: [
      { name: "Bacias IAT", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>' },
      { name: "Nível de Dificuldade", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>' },
      { name: "Rodovias", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>' },
      { name: "Hidrografia", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>' },
      { name: "Camada de Áreas Urbanas", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>' },
      { name: "Camada de Declividade", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>' },
      { name: "Camada de Manchas de Clima", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>' },
      { name: "Camada de Precipitação", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>' },
      { name: "Camada de Vegetação", layer: L.tileLayer(''), icon: '<i class="icon icon-layer"></i>' }
    ]
  }
];